import React, { ReactNode } from 'react';
import { TextList, TextListItem } from '@naf/text-list';
import { BlockContentContext } from '../../BlockContent.utils';
import { ArticleWrapper } from './ArticleListWrapper';

interface ListComponentProps {
  variant: 'bullet' | 'number' | 'check' | 'close';
  children?: ReactNode;
  context?: BlockContentContext;
}

export const ListComponent = ({ variant, children, context }: ListComponentProps) => {
  const isArticle = context === BlockContentContext.Article;
  return (
    <ArticleWrapper isArticle={isArticle} styleName="list">
      <TextList variant={variant}>
        {Array.isArray(children)
          ? children.map((c: any) => <TextListItem key={c.key}>{c.props.children}</TextListItem>)
          : null}
      </TextList>
    </ArticleWrapper>
  );
};
